import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import { RadioButton as RadioButton$2, Input, Label, Circle, LabelContent } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "className", "disabled", "invalid", "onChange", "uniqueId", "name", "checked", "style", "hideLabel", "disabledSelected", "presentationOnly"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RadioButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    onChange = _ref.onChange,
    uniqueId = _ref.uniqueId,
    name = _ref.name,
    checked = _ref.checked,
    style = _ref.style,
    hideLabel = _ref.hideLabel,
    disabledSelected = _ref.disabledSelected,
    presentationOnly = _ref.presentationOnly,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!presentationOnly && typeof onChange !== 'function') {
    return false;
  }
  return /*#__PURE__*/jsxs(RadioButton$2, {
    className: className,
    style: style,
    children: [/*#__PURE__*/jsx(Input, _objectSpread({
      as: presentationOnly ? 'div' : undefined,
      onChange: !disabled && !disabledSelected && !presentationOnly ? onChange : null,
      name: name,
      id: uniqueId,
      type: presentationOnly ? undefined : 'radio',
      checked: presentationOnly ? undefined : checked,
      "aria-checked": presentationOnly ? undefined : checked,
      "aria-disabled": presentationOnly ? undefined : disabled || disabledSelected,
      readOnly: presentationOnly ? undefined : disabled,
      ref: ref
    }, rest)), /*#__PURE__*/jsxs(Label, {
      as: presentationOnly ? 'div' : undefined,
      $disabled: disabled,
      className: "sg-radio-button__label",
      htmlFor: presentationOnly ? undefined : uniqueId,
      children: [/*#__PURE__*/jsx(Circle, {
        $disabled: disabled,
        $invalid: invalid,
        $checked: checked,
        $disabledSelected: disabledSelected
      }), children && /*#__PURE__*/jsx(LabelContent, {
        className: hideLabel ? 'visually-hidden' : null,
        children: children
      })]
    })]
  });
});
RadioButton.displayName = 'RadioButton';
RadioButton.defaultProps = {
  onChange: function onChange() {},
  className: null,
  disabled: null,
  invalid: null,
  name: null,
  checked: false,
  style: null,
  hideLabel: false,
  disabledSelected: null,
  presentationOnly: false
};
var RadioButton$1 = RadioButton;

export { RadioButton$1 as default };
//# sourceMappingURL=RadioButton.js.map
